import { Button, message, Select, SelectProps } from 'antd';
import PolicyAgreement from './PolicyAgreement';
import { useEffect, useState } from 'react';
import StockServices from '@root/modules/Sellers/Stock/services/stock';
import mypage from '../services/mypage';

type TData = {
  name: string;
  id: number;
};

type TSelectProps = {
  label: string;
  value: number;
};

const IntergrateShopee = () => {
  const [options, setOptions] = useState<TSelectProps[]>([]);
  const [agreePolicy, setAgreePolicy] = useState(false);
  const [warehouseId, setWarehouseId] = useState<number | null>(null);
  
  const getOptions = async () => {
    const res = await StockServices.getPaging({
      page: 0,
      limit: 100
    });

    if (res && res.data) {
      const data = res.data;
      const options = data.map((item: TData) => ({
        label: item.name,
        value: item.id
      }));
      setOptions(options);
    }
  };

  useEffect(() => {
    getOptions();
  }, []);

  const handleChange = (value: number) => {
    setWarehouseId(value);
  };

  const startIntegration = async () => {
    try {
      const redirectUrl =
        window.location.origin +
        '/admin/seller/mypage?tab=2' +
        `&warehouseId=${warehouseId}`;
      console.log(redirectUrl);
      const res = await mypage.startIntegration({ redirectUrl });
      if (res && res.url) {
        window.location.href = res.url;
      }
    } catch (error) {
      console.log('error', error);
      message.error('연동에 실패했습니다.');
    }
  };

  return (
    <div
      className="flex flex-vertical"
      style={{
        gap: '24px'
      }}
    >
      <div className="account-wrapper button-wrapper flex gap-17">
        <Select
          style={{ width: '454px'}}
          placeholder="연동할 물류센터를 선택해주세요"
          onChange={handleChange}
          options={options}
          className="border-input"
        />
        {warehouseId && agreePolicy && (
          <Button
            type="primary"
            className="btn-primary"
            onClick={startIntegration}
            style={{height: 45}}
          >
            연동하러 가기
          </Button>
        )}
      </div>

      <PolicyAgreement
        setAgreePolicy={setAgreePolicy}
        agreePolicy={agreePolicy}
      />
    </div>
  );
};

export default IntergrateShopee;
